/**
 * Générateurs des ITEMS NATIONAUX : français, 6e, Compréhension de l'écrit Document Sommeil, campagne 2026.
 * Même contrat que les modules de maths (2026/6e/automatismes.js, le modèle) : un générateur par item, sa
 * fiche en tête (lue sur la CAPTURE de l'item), ITEMS avec la bonne réponse officielle exacte, CATEGORIES,
 * generate.
 *
 * VARIANTES FIXES : une variante par item, posée sur UN NOUVEAU DOCUMENT (SUPPORT), « Les dents et le sucre »,
 * écrit pour TanoEd. Sujet choisi en mode auto, TRANCHÉ LE 11/10 (on garde) : un autre document de santé que le sommeil, retenu
 * parce qu'il a, comme le sommeil, un vrai cycle à durées vérifiables (l'attaque acide qui suit chaque prise
 * alimentaire, la courbe de Stephan). La digestion, l'activité physique, l'eau du corps et l'attention ont été
 * écartées : leurs durées changent d'une source sérieuse à l'autre (la digestion : estomac « 2 à 4 h » ici,
 * « 4 à 6 h » là), ou ne sont que des conseils (la séance de sport), ce qui casserait le piège de Q07.
 * Le document est construit comme celui de septembre, six pages, chacune dans le rôle de la page
 * correspondante :
 *   page 1 : un dessin qui fait comprendre un excès, les sucreries de la journée avec leurs quantités, et son
 *     effet : l'enfant se tient la joue devant son assiette, sous un « Bon appétit ! » ;
 *   page 2 : le titre de l'article (« Bonbons et sodas : les faux amis des dents »), la phrase au mot de Q03,
 *     deux constats, puis « Comment le sucre abîme-t-il les dents ? » et le premier intertitre ;
 *   page 3 : la suite, trois intertitres, chacun avec sa cause (le grignotage, les sucres qui collent,
 *     l'acidité des boissons), et la source ;
 *   page 4 : les conséquences sur la santé, sous un titre de presse (« La carie fait aussi manquer l'école ») ;
 *   page 5 : un schéma en cercle, « Le cycle de l'attaque acide » : cinq phases, deux durées (environ 3 et
 *     environ 20 minutes), le retour à l'état normal (30 minutes à 1 heure) et le nombre de cycles par jour ;
 *   page 6 : « Qu'est-ce qu'une bouche en bonne santé ? », une définition par critères, sans aucun conseil
 *     (le piège de Q07 : une définition lue comme des astuces).
 * Longueur : 486 mots de texte suivi sur les pages 2, 3, 4 et 6 (septembre : 489) ; 547 avec les titres des
 * pages et la légende du schéma (septembre : 539 avec ses titres et ses légendes). Même niveau de langue : des
 * phrases courtes, quelques mots savants expliqués par le texte (émail, plaque dentaire, érosion), comme
 * « sédentarité » et « mélatonine » en septembre.
 * Images : deux SVG faits maison (le dessin, le schéma), source « Illustration TanoEd ». Le dessin ne dit pas
 * ce que l'enfant n'arrive pas à faire ni ce que l'auteur pense des quantités : il les montre.
 *
 * Sources des faits (relues le 11/10/2026 ; aucun chiffre inventé, aucune phrase prêtée à une personne) :
 *   - OMS, « Sucres et caries dentaires » (who.int/fr/news-room/fact-sheets/detail/sugars-and-dental-caries) :
 *     les caries apparaissent lors de la transformation en acides des sucres libres présents dans la plaque
 *     dentaire ; les sucres libres comprennent ceux des jus de fruits ; douleur, difficultés pour manger,
 *     parler, respirer ou dormir ; « Chez les enfants, la carie dentaire entraîne souvent un absentéisme
 *     scolaire. »
 *   - Gouvernement du Québec, « Carie dentaire » (quebec.ca/sante/problemes-de-sante/a-z/carie-dentaire, pages
 *     Symptômes, Facteurs de risque, Complications) : la carie se développe lentement et détruit
 *     progressivement la dent ; émail : aucune douleur ; dentine : dent sensible au chaud et au froid ;
 *     pulpe : douleur soudaine, vive et continuelle, la rage de dents ; abcès : enflure de la joue, douleur
 *     quand on mâche, fièvre ; l'infection peut obliger à arracher la dent ; facteurs : sucreries entre les
 *     repas, petites portions sucrées réparties dans la journée, collations collantes coincées entre les
 *     dents, sucreries le soir ; plus le sucre reste au contact des dents, plus le risque est grand ; la
 *     salive, plus abondante pendant les repas, protège les dents ; la bouche en produit moins la nuit et
 *     entre les repas.
 *   - UFSBD (Union française pour la santé bucco-dentaire), fiche « Attention au grignotage ! », mars 2025
 *     (ufsbd.fr/wp-content/uploads/2025/03/UFSBD-fiche-patient-grignotage.pdf) : « Chaque prise alimentaire
 *     crée une acidité en bouche » ; le grignoteur multiplie les attaques acides, qui abîment l'émail ; les
 *     aliments collants et fondants favorisent les bactéries des caries ; son schéma : une attaque acide par
 *     repas, quatre repas par jour (petit déjeuner, déjeuner, goûter, dîner).
 *   - Société suisse des médecins-dentistes (SSO), « Erosions dentaires », 2015 (sso.ch/it/media/805/download) :
 *     l'émail est la couche de « revêtement » de la dent ; l'érosion ronge l'émail par des acides, « sans que
 *     des bactéries ne soient primairement impliquées » ; soft-drinks, jus de fruits, boissons pour sportifs ;
 *     « L'émail rongé par les acides est irrémédiablement perdu » ; la salive neutralise les acides et répare
 *     l'émail en lui rendant ses minéraux.
 *   - Le cycle (page 5), d'après la courbe de Stephan : Dimensions of Dental Hygiene, « The Role of Nutrition
 *     in Dental Caries », avril-mai 2024 (dimensionsofdentalhygiene.com) : le pH atteint le seuil acide dans
 *     les 3 premières minutes et y reste environ 20 minutes ; Stephan et Miller (années 1940, cités par le
 *     glossaire de dentalcare.com) et l'encyclopédie médicale DocCheck Flexikon (« Stephan-Kurve ») : retour à
 *     l'état normal en 30 à 60 minutes ; au-dessus du seuil, la salive reminéralise l'émail. Les mesures
 *     varient pour la descente du pH (DocCheck : 5 à 10 minutes ; d'autres : 2 à 5) : « environ 3 minutes »
 *     suit la revue de 2024, mode auto, TRANCHÉ LE 11/10 (on garde) ; les 20 minutes et le retour en 30 à 60 minutes sont les
 *     valeurs classiques de Stephan et Miller.
 *   - Manuel MSD, « Gingivite » (msdmanuals.com/fr/professional) : des gencives normales sont fermes, bien
 *     adaptées aux dents, roses, et ne saignent pas quand on appuie dessus ; la gingivite les rend rouges,
 *     gonflées, et les fait saigner.
 *   - Q08, l'information ajoutée : Minnesota Dental Association, « Pucker Up! The Effects of Sour Candy on Oral
 *     Health » (mndental.org) : les bonbons acidulés contiennent beaucoup d'acide, qui use l'émail ; et le
 *     Journal of the American Dental Association, 2009 (érosion par les bonbons acidulés).
 *
 * Chaque question garde l'attendu, le type, la difficulté et les pièges de l'item : chaque mauvaise réponse
 * officielle a sa raison (fiche de l'item), la variante en fabrique une de même nature sur le nouveau document.
 * Le document voyage avec chaque variante (utils/supportLecture.js) : le livre du quiz l'ouvre à la place de
 * celui de septembre. Second chemin (REGLES_EQUIPE § 3) : chaque générateur vérifie que les passages qui servent
 * sa bonne réponse et ses pièges sont bien là où il les cherche (page, phase du schéma, étiquette du dessin),
 * sinon il lève une erreur. Les tableaux (Q06, Q09) passent en « association », comme l'item que le quiz
 * reconstruit depuis sa bonne réponse : une colonne cochée sur une ligne se retire des autres.
 */
import { randomChoice, makeQcm, makeVraiFaux } from '../../../../utils';
import { normalizeAnswer } from '../../../../../utils/questionUtils';
import { avecSupportLecture } from '../../../../../utils/supportLecture';

/** Une variante par item, sur le nouveau document : l'alerte de variété du harnais est attendue. */
export const VARIANTES_FIXES = true;

const opts = (label) => ({ niveau: '6eme', matiere: 'francais', attendu: null, label });

// ─── Le document : le dessin, le schéma et les pages (cette partie n'utilise aucun import) ───

const px = (v) => Math.round(v * 10) / 10;
const ENCRE = '#1f2937';
const PEAU = '#f5cfae';
const PEAU_TRAIT = '#9a6a4a';
const POLICE = 'Arial, Helvetica, sans-serif';
/** L'écriture à la main des étiquettes du dessin ; Arial si la machine n'a aucune de ces polices. */
const POLICE_MAIN = '\'Comic Sans MS\', \'Comic Neue\', \'Chalkboard SE\', Arial, sans-serif';

const echappe = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const texteSvg = (x, y, s, { taille = 16, gras = false, ancre = 'start', police = POLICE } = {}) =>
    `<text x="${px(x)}" y="${px(y)}" font-size="${taille}"${gras ? ' font-weight="700"' : ''} fill="${ENCRE}"`
    + ` text-anchor="${ancre}" font-family="${police}">${echappe(s)}</text>`;
const racineSvg = (largeur, hauteur, alt, contenu) =>
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${largeur} ${hauteur}" width="${largeur}" role="img"`
    + ` aria-label="${alt}">${contenu}</svg>`;
const enUrl = (svg) => `data:image/svg+xml,${encodeURIComponent(svg)}`;

/** Une flèche dessinée à la main : une courbe, puis une pointe dans la direction d'arrivée. */
const fleche = (x1, y1, cx, cy, x2, y2) => {
    const angle = Math.atan2(y2 - cy, x2 - cx);
    const branche = (a) => `${px(x2 + 11 * Math.cos(a))} ${px(y2 + 11 * Math.sin(a))}`;
    return `<path d="M ${px(x1)} ${px(y1)} Q ${px(cx)} ${px(cy)} ${px(x2)} ${px(y2)}" fill="none" stroke="${ENCRE}"`
        + ' stroke-width="2.2" stroke-linecap="round"/>'
        + `<path d="M ${branche(angle + Math.PI * 0.82)} L ${px(x2)} ${px(y2)} L ${branche(angle - Math.PI * 0.82)}"`
        + ` fill="none" stroke="${ENCRE}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>`;
};

/** Le contour d'une tête à la joue enflée : la réunion de deux cercles (la tête, la joue). */
const teteEnflee = ([x1, y1], r1, [x2, y2], r2) => {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const d = Math.hypot(dx, dy);
    const a = (r1 * r1 - r2 * r2 + d * d) / (2 * d);
    const h = Math.sqrt(r1 * r1 - a * a);
    const [mx, my] = [x1 + (a * dx) / d, y1 + (a * dy) / d];
    const bas = `${px(mx - (h * dy) / d)} ${px(my + (h * dx) / d)}`;
    const haut = `${px(mx + (h * dy) / d)} ${px(my - (h * dx) / d)}`;
    return `M ${haut} A ${r1} ${r1} 0 1 0 ${bas} A ${r2} ${r2} 0 1 0 ${haut} Z`;
};

/** Une canette de soda écrasée, debout. */
const canette = (x, y, rotation) => `<g transform="rotate(${rotation} ${x + 12} ${y + 46})">`
    + `<rect x="${x}" y="${y}" width="24" height="46" rx="4" fill="#d64541" stroke="#7a1f1f" stroke-width="2"/>`
    + `<rect x="${x}" y="${y + 13}" width="24" height="7" fill="#ffffff" opacity="0.55"/>`
    + `<polyline points="${x},${y + 30} ${x + 7},${y + 25} ${x + 14},${y + 33} ${x + 24},${y + 27}" fill="none"`
    + ' stroke="#7a1f1f" stroke-width="2" stroke-linejoin="round"/>'
    + `<ellipse cx="${x + 12}" cy="${y}" rx="12" ry="3.5" fill="#cfd4da" stroke="#7a1f1f" stroke-width="1.5"/></g>`;

/** Les étiquettes du dessin : les quantités de la journée (Q01 et Q02 s'y appuient). */
const ETIQUETTES = {
    canettes: '3 canettes de soda',
    bonbons: '1 paquet de bonbons',
    biscuits: '6 biscuits',
    barres: '2 barres chocolatées',
};
const BULLE = 'Bon appétit !';
const ALT_DESSIN = 'Dessin : à table, devant son assiette, un enfant se tient la joue ; autour de lui, les'
    + ' emballages de ses sucreries, avec leurs quantités.';

const dessinPage1 = () => racineSvg(560, 400, ALT_DESSIN, [
    '<rect x="0" y="0" width="560" height="400" fill="#fdf7ea"/>',
    '<rect x="0" y="356" width="560" height="44" fill="#efe3cf"/>',
    // l'enfant, derrière la table
    '<path d="M 205 300 L 205 262 Q 210 232 250 226 L 310 226 Q 350 232 355 262 L 355 300 Z" fill="#5b8fd6"'
        + ' stroke="#2f5d99" stroke-width="2.5"/>',
    `<rect x="268" y="206" width="24" height="24" fill="${PEAU}" stroke="${PEAU_TRAIT}" stroke-width="2"/>`,
    `<ellipse cx="223" cy="164" rx="8" ry="12" fill="${PEAU}" stroke="${PEAU_TRAIT}" stroke-width="2"/>`,
    `<path d="${teteEnflee([280, 158], 58, [326, 184], 27)}" fill="${PEAU}" stroke="${PEAU_TRAIT}" stroke-width="2.5"/>`,
    '<ellipse cx="329" cy="186" rx="15" ry="11" fill="#f28b82" opacity="0.6"/>',
    '<path d="M 222 152 C 218 102 262 86 290 95 C 322 100 342 122 337 152 C 326 130 306 118 284 123'
        + ' C 262 118 238 128 222 152 Z" fill="#5a3825" stroke="#3b2417" stroke-width="2"/>',
    // les yeux plissés, les sourcils, la bouche de travers
    `<polyline points="250,146 264,154 250,162" fill="none" stroke="${ENCRE}" stroke-width="3" stroke-linecap="round"`
        + ' stroke-linejoin="round"/>',
    `<polyline points="308,146 294,154 308,162" fill="none" stroke="${ENCRE}" stroke-width="3" stroke-linecap="round"`
        + ' stroke-linejoin="round"/>',
    `<path d="M 246 136 L 266 131 M 292 131 L 312 136" stroke="${ENCRE}" stroke-width="3" stroke-linecap="round"/>`,
    `<path d="M 258 192 q 5 -6 10 0 q 5 6 10 0 q 5 -6 10 0" fill="none" stroke="${ENCRE}" stroke-width="2.6"`
        + ' stroke-linecap="round"/>',
    // le bras, la main posée sur la joue enflée
    '<path d="M 330 232 L 360 232 L 376 268 L 350 278 Z" fill="#5b8fd6" stroke="#2f5d99" stroke-width="2.5"'
        + ' stroke-linejoin="round"/>',
    `<path d="M 364 262 L 356 212" stroke="${PEAU_TRAIT}" stroke-width="23" stroke-linecap="round"/>`,
    `<path d="M 364 262 L 356 212" stroke="${PEAU}" stroke-width="19" stroke-linecap="round"/>`,
    `<ellipse cx="352" cy="190" rx="17" ry="24" fill="${PEAU}" stroke="${PEAU_TRAIT}" stroke-width="2.2"/>`,
    `<path d="M 340 178 L 348 179 M 339 189 L 347 190 M 340 200 L 348 200" stroke="${PEAU_TRAIT}" stroke-width="1.6"`
        + ' stroke-linecap="round"/>',
    // les traits de douleur
    '<path d="M 378 160 l 8 -7 l 2 9 l 9 -7 M 383 194 l 10 -4 l 1 9 l 10 -4 M 377 226 l 8 2 l -2 8 l 9 2"'
        + ' fill="none" stroke="#e04848" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>',
    // la table
    '<polygon points="40,282 520,282 540,322 20,322" fill="#e3b27a" stroke="#9a6a3a" stroke-width="2.5"'
        + ' stroke-linejoin="round"/>',
    '<rect x="20" y="322" width="520" height="34" fill="#c98f55" stroke="#9a6a3a" stroke-width="2.5"/>',
    // l'assiette pleine, la fourchette posée à côté
    '<ellipse cx="280" cy="302" rx="74" ry="16" fill="#ffffff" stroke="#9ca3af" stroke-width="2"/>',
    '<ellipse cx="280" cy="301" rx="54" ry="10" fill="none" stroke="#e5e7eb" stroke-width="2"/>',
    '<ellipse cx="262" cy="299" rx="18" ry="6.5" fill="#9c5a3c" stroke="#6b3a24" stroke-width="1.5"/>',
    ...[[288, 297], [296, 301], [287, 303], [303, 297], [295, 295], [305, 302]]
        .map(([x, y]) => `<circle cx="${x}" cy="${y}" r="3.6" fill="#6aa84f" stroke="#3d6b2a" stroke-width="1"/>`),
    '<path d="M 312 300 l 14 -3 M 314 304 l 13 -2" stroke="#f08c2b" stroke-width="4.5" stroke-linecap="round"/>',
    '<path d="M 368 310 L 404 305" stroke="#8d99ae" stroke-width="4.5" stroke-linecap="round"/>',
    '<path d="M 404 305 L 418 303 M 404 302 L 417 299 M 405 308 L 419 307" stroke="#8d99ae" stroke-width="2"'
        + ' stroke-linecap="round"/>',
    // les canettes écrasées, donc vides : deux debout, une couchée
    canette(60, 250, -6),
    canette(94, 248, 7),
    '<g transform="rotate(-3 58 309)"><rect x="34" y="299" width="46" height="21" rx="4" fill="#d64541"'
        + ' stroke="#7a1f1f" stroke-width="2"/><polyline points="50,299 54,306 48,313 52,320" fill="none"'
        + ' stroke="#7a1f1f" stroke-width="2"/><ellipse cx="80" cy="309.5" rx="3.5" ry="10.5" fill="#cfd4da"'
        + ' stroke="#7a1f1f" stroke-width="1.5"/></g>',
    // le paquet de biscuits déchiré, vide, et ses miettes
    '<path d="M 128 314 L 128 297 L 186 295 L 181 300 L 187 304 L 181 308 L 187 312 Z" fill="#f2d29b"'
        + ' stroke="#a0743d" stroke-width="2" stroke-linejoin="round"/>',
    '<path d="M 140 300 L 140 310 M 152 299 L 152 310" stroke="#d9b277" stroke-width="2"/>',
    ...[[193, 306], [199, 310], [195, 301], [203, 304]].map(([x, y]) => `<circle cx="${x}" cy="${y}" r="2" fill="#c8964f"/>`),
    // le paquet de bonbons vide : couché, froissé, ouvert
    '<path d="M 424 312 L 428 290 L 476 286 L 482 294 L 476 298 L 483 304 L 476 309 Z" fill="#9b5de5"'
        + ' stroke="#5b2a9e" stroke-width="2" stroke-linejoin="round"/>',
    '<path d="M 436 292 L 440 309 M 452 290 L 449 307 M 464 289 L 467 306" stroke="#f15bb5" stroke-width="3"/>',
    // les papiers vides des barres chocolatées
    '<g transform="rotate(-8 512 312)"><rect x="490" y="305" width="44" height="12" rx="2" fill="#6b3e26"'
        + ' stroke="#3e2314" stroke-width="1.5"/><path d="M 534 305 L 540 308 L 534 311 L 540 314 L 534 317"'
        + ' fill="#c0c7cf" stroke="#3e2314" stroke-width="1"/></g>',
    '<g transform="rotate(5 478 318)"><rect x="458" y="313" width="40" height="11" rx="2" fill="#7b4a2e"'
        + ' stroke="#3e2314" stroke-width="1.5"/><path d="M 458 313 L 452 316 L 458 319 L 452 322 L 458 324"'
        + ' fill="#c0c7cf" stroke="#3e2314" stroke-width="1"/></g>',
    // les étiquettes, écrites à la main, et leurs flèches
    texteSvg(18, 58, ETIQUETTES.canettes, { taille: 20, police: POLICE_MAIN }),
    fleche(70, 68, 58, 160, 84, 238),
    texteSvg(548, 112, ETIQUETTES.bonbons, { taille: 20, police: POLICE_MAIN, ancre: 'end' }),
    fleche(478, 124, 500, 210, 458, 280),
    texteSvg(22, 391, ETIQUETTES.biscuits, { taille: 20, police: POLICE_MAIN }),
    fleche(118, 384, 160, 380, 158, 320),
    texteSvg(548, 391, ETIQUETTES.barres, { taille: 20, police: POLICE_MAIN, ancre: 'end' }),
    fleche(500, 372, 494, 352, 490, 326),
    // la bulle d'une personne hors du dessin
    '<path d="M 402 14 L 528 14 Q 540 14 540 26 L 540 34 L 556 42 L 540 46 L 540 52 Q 540 64 528 64 L 402 64'
        + ' Q 390 64 390 52 L 390 26 Q 390 14 402 14 Z" fill="#ffffff" stroke="#374151" stroke-width="2.2"'
        + ' stroke-linejoin="round"/>',
    texteSvg(465, 47, BULLE, { taille: 21, police: POLICE_MAIN, ancre: 'middle' }),
].join(''));

/**
 * Les phases du schéma de la page 5, dans l'ordre du cycle (Q05 et Q06 s'y appuient). Durées : environ
 * 3 minutes pour que la bouche devienne acide, environ 20 minutes d'attaque de l'émail (courbe de Stephan,
 * voir les sources) ; aucun nom de phase ne partage de mot avec la description de la phase.
 */
const PHASES = [
    { nom: 'Repas', lignes: ['On mange', 'ou on boit.'], duree: null, couleur: '#fde68a' },
    { nom: 'Acidification', lignes: ['Les bactéries', 'changent le sucre', 'en acide.'], duree: 'environ 3 minutes', couleur: '#fdba74' },
    { nom: 'Déminéralisation', lignes: ['L\'émail perd', 'des minéraux.', 'On ne sent rien.'], duree: 'environ 20 minutes', couleur: '#fca5a5' },
    { nom: 'Neutralisation', lignes: ['La salive chasse', 'l\'acide.'], duree: null, couleur: '#93c5fd' },
    { nom: 'Reminéralisation', lignes: ['L\'émail récupère', 'des minéraux,', 'jusqu\'au repas', 'suivant.'], duree: null, couleur: '#86efac' },
];
const LEGENDE_CYCLE = 'Après chaque repas, la bouche met 30 minutes à 1 heure à retrouver son état normal. Chaque'
    + ' prise alimentaire lance un nouveau cycle : avec quatre repas par jour, la bouche connaît quatre cycles.';
const ALT_SCHEMA = 'Schéma en cercle : les cinq phases du cycle de l\'attaque acide, de Repas à Reminéralisation,'
    + ' avec leurs durées.';

const rad = (degres) => (degres * Math.PI) / 180;
const point = (cx, cy, r, degres) => [cx + r * Math.cos(rad(degres)), cy + r * Math.sin(rad(degres))];

/** Un secteur d'anneau en forme de flèche : encoche à l'entrée, pointe à la sortie (sens des aiguilles d'une montre). */
const secteurFleche = (cx, cy, rIn, rOut, a0, a1, couleur) => {
    const pointe = 7;
    const rMid = (rIn + rOut) / 2;
    const p = (r, a) => point(cx, cy, r, a).map(px).join(' ');
    const grand = a1 - pointe - a0 > 180 ? 1 : 0;
    return `<path d="M ${p(rOut, a0)} A ${rOut} ${rOut} 0 ${grand} 1 ${p(rOut, a1 - pointe)} L ${p(rMid, a1)}`
        + ` L ${p(rIn, a1 - pointe)} A ${rIn} ${rIn} 0 ${grand} 0 ${p(rIn, a0)} L ${p(rMid, a0 + pointe)} Z"`
        + ` fill="${couleur}" stroke="#ffffff" stroke-width="3" stroke-linejoin="round"/>`;
};

const schemaPage5 = () => {
    const [cx, cy, rIn, rOut] = [280, 262, 78, 250];
    const pas = 360 / PHASES.length;
    const secteurs = PHASES.map((ph, i) => secteurFleche(cx, cy, rIn, rOut, -90 + i * pas - pas / 2 + 1, -90 + i * pas + pas / 2 - 1, ph.couleur));
    const textes = PHASES.flatMap((ph, i) => {
        const [tx, ty] = point(cx, cy, 168, -90 + i * pas);
        const lignes = [
            { s: ph.nom, taille: 18, gras: true },
            ...ph.lignes.map((s) => ({ s, taille: 14.5, gras: false })),
            ...(ph.duree ? [{ s: ph.duree, taille: 14.5, gras: true }] : []),
        ];
        const hauteur = lignes.reduce((total, l) => total + l.taille * 1.22, 0);
        let y = ty - hauteur / 2 + lignes[0].taille - lignes[0].taille * 1.22;
        return lignes.map((l) => {
            y += l.taille * 1.22;
            return texteSvg(tx, y, l.s, { taille: l.taille, gras: l.gras, ancre: 'middle' });
        });
    });
    // une dent au centre, pour le décor
    const dent = `<path d="M ${cx - 30} ${cy - 26} C ${cx - 30} ${cy - 44} ${cx - 12} ${cy - 46} ${cx} ${cy - 38}`
        + ` C ${cx + 12} ${cy - 46} ${cx + 30} ${cy - 44} ${cx + 30} ${cy - 26} C ${cx + 30} ${cy - 6} ${cx + 22} ${cy + 4}`
        + ` ${cx + 18} ${cy + 22} C ${cx + 15} ${cy + 38} ${cx + 6} ${cy + 40} ${cx + 4} ${cy + 26} C ${cx + 2} ${cy + 14}`
        + ` ${cx - 2} ${cy + 14} ${cx - 4} ${cy + 26} C ${cx - 6} ${cy + 40} ${cx - 15} ${cy + 38} ${cx - 18} ${cy + 22}`
        + ` C ${cx - 22} ${cy + 4} ${cx - 30} ${cy - 6} ${cx - 30} ${cy - 26} Z" fill="#ffffff" stroke="#64748b" stroke-width="2.5"/>`;
    return racineSvg(560, 520, ALT_SCHEMA, ['<rect x="0" y="0" width="560" height="520" fill="#ffffff"/>', ...secteurs, ...textes, dent].join(''));
};

/** Le nouveau document, en six pages comme celui de septembre ; texte brut, une ligne vide entre les paragraphes. */
export const SUPPORT = {
    id: 'sommeil-2026-variante-1',
    titre: 'Les dents et le sucre',
    pages: [
        {
            page: 1,
            title: 'Les dents',
            content: '',
            images: [{ src: enUrl(dessinPage1()), alt: ALT_DESSIN }],
            source: 'Illustration TanoEd',
        },
        {
            page: 2,
            title: 'Les dents et le sucre',
            content: `Bonbons et sodas : les faux amis des dents

Les bonbons, les biscuits, les jus de fruits et les boissons gazeuses sucrées sont associés à des caries et à une usure de l'émail.

Les enfants qui grignotent des sucreries entre les repas, ou qui boivent un soda par petites gorgées tout au long de l'après-midi, ont un risque plus élevé d'avoir des caries : leurs dents restent plus longtemps au contact du sucre.

Plus ce contact dure, plus le risque est grand. Ainsi, les sucreries mangées le soir, juste avant de dormir, sont particulièrement nocives, car pendant la nuit la bouche produit moins de salive.

Comment le sucre abîme-t-il les dents ?

Des bactéries gourmandes

Dans la bouche vivent des bactéries. Elles forment sur les dents un film collant, difficile à voir : la plaque dentaire.`,
        },
        {
            page: 3,
            title: '',
            content: `Ces bactéries se nourrissent du sucre et le transforment en acide. Cet acide attaque l'émail, la couche dure qui protège la dent.

Des attaques à répétition

Chaque prise alimentaire rend la bouche acide pendant un moment. Quand on grignote toute la journée, les attaques acides s'enchaînent : la salive, qui protège les dents, n'a plus le temps de réparer l'émail entre deux attaques.

Des sucres qui collent

Les caramels, les bonbons mous et certains biscuits restent coincés entre les dents. Le sucre reste alors longtemps au contact de l'émail, surtout entre les repas, quand la salive est moins abondante.

Une érosion de l'émail

Enfin, les sodas, les jus de fruits et les boissons pour sportifs sont acides. Leur acidité ronge directement l'émail, sans l'aide des bactéries : c'est l'érosion. Or l'émail rongé ne repousse jamais.

D'après www.quebec.ca, www.ufsbd.fr et www.sso.ch`,
        },
        {
            page: 4,
            title: 'Les conséquences des caries sur la santé',
            content: `La carie fait aussi manquer l'école

Une carie se développe lentement et détruit peu à peu la dent. Au début, elle ne fait pas mal. Puis la dent devient sensible au chaud et au froid. Plus tard, la douleur peut devenir soudaine, vive et continuelle : c'est la rage de dents.

Sans soin, une carie peut aussi provoquer un abcès, accompagné parfois de fièvre et d'une enflure du visage. L'infection peut même obliger à arracher la dent.

Selon l'Organisation mondiale de la santé, les caries causent des difficultés pour manger, pour parler ou pour dormir. Chez les enfants, elles entraînent souvent des absences à l'école.

Les caries ont donc des répercussions sur la santé, mais aussi sur la vie de tous les jours et sur la scolarité des enfants.

D'après www.quebec.ca et www.who.int`,
        },
        {
            page: 5,
            title: 'Le cycle de l\'attaque acide',
            content: '',
            images: [{ src: enUrl(schemaPage5()), alt: ALT_SCHEMA }],
            legende: LEGENDE_CYCLE,
            source: 'Illustration TanoEd',
        },
        {
            page: 6,
            title: 'Qu\'est-ce qu\'une bouche en bonne santé ?',
            content: `Selon les dentistes, on peut dire qu'une bouche est en bonne santé si :

- les gencives sont roses et fermes, bien serrées autour des dents ;

- elles ne sont ni rouges ni gonflées, et ne saignent pas quand on appuie dessus ;

- aucune dent ne fait mal, ni au contact du chaud ou du froid, ni quand on mâche.

D'après www.msdmanuals.com et www.quebec.ca`,
        },
    ],
};

// ─── Fin du document ───

/** Second chemin (REGLES_EQUIPE § 3) : un document qui ne sert plus la question lève une erreur au lieu de partir. */
const garde = (condition, message) => {
    if (!condition) throw new Error(`Item national de français 6e (Document Sommeil, variante), ${message}`);
};
const page = (n) => SUPPORT.pages[n - 1];
/** Les passages [page, extrait] qui servent une question sont bien sur les pages citées. */
const appuis = (question, passages) => passages.forEach(([n, extrait]) => {
    garde((page(n)?.content || '').includes(extrait), `${question} : « ${extrait} » absent de la page ${n}`);
});
const phase = (nom) => {
    const trouvee = PHASES.find((p) => p.nom === nom);
    garde(trouvee, `phase « ${nom} » absente du schéma`);
    return trouvee;
};
/** La description d'une phase telle que le schéma l'écrit, ses lignes mises bout à bout. */
const descriptionDe = (nom) => phase(nom).lignes.join(' ');
/** Tout le texte que l'élève peut lire : titres, pages, légende, étiquettes, bulle et schéma. */
const texteDuDocument = () => [
    ...SUPPORT.pages.flatMap((p) => [p.title, p.content, p.legende || '', p.source || '']),
    ...Object.values(ETIQUETTES), BULLE,
    ...PHASES.flatMap((p) => [p.nom, ...p.lignes, p.duree || '']),
].join('\n');
/** Rien d'affiché ne porte de tiret cadratin (U+2014, écrit par son code : le caractère n'est pas dans ce fichier). */
const CADRATIN = String.fromCharCode(0x2014);
const sansCadratin = (label, textes) => garde(textes.every((s) => !s.includes(CADRATIN)), `${label} : tiret cadratin`);

/** Le QCM d'un item sur le nouveau document : quatre choix en texte, le juste en premier (makeQcm les mélange). */
const qcmSurLeDocument = (choix, texte, label) => {
    garde(choix.length === 4 && new Set(choix.map(normalizeAnswer)).size === 4, `${label} : quatre choix différents`);
    sansCadratin(label, [texte, ...choix, texteDuDocument()]);
    return avecSupportLecture(makeQcm(choix, choix[0], texte, opts(label)), SUPPORT);
};

/**
 * Le tableau d'un item : [ligne, colonne juste] par ligne, les colonnes de l'item. Chaque colonne sert une seule
 * fois (une bijection, comme l'item) ; le format [ligne|colonne] interdit crochets et barre verticale.
 */
const tableauSurLeDocument = (lignes, colonnes, texte, label) => {
    const index = lignes.map(([, colonne]) => colonnes.indexOf(colonne));
    garde(lignes.length === colonnes.length && index.every((i) => i >= 0) && new Set(index).size === index.length,
        `${label} : chaque colonne sert une fois`);
    garde([...lignes.map(([ligne]) => ligne), ...colonnes].every((s) => !/[[\]|]/.test(s)), `${label} : ni crochet ni barre`);
    sansCadratin(label, [texte, ...lignes.map(([ligne]) => ligne), ...colonnes, texteDuDocument()]);
    const payload = makeVraiFaux(lignes.map(([ligne]) => ligne), index, texte, { ...opts(label), colonnes });
    const table = payload.elements_additionnels.elements.find((e) => e.type === 'table');
    table.config = { ...table.config, type: 'association' };
    return avecSupportLecture(payload, SUPPORT);
};

/**
 * Q01 : Ce que le dessin fait comprendre
 * Item : « Sur le dessin de la page 1, l'enfant a les yeux grands ouverts car il n'arrive pas à… » (Mettre en
 *   relation des informations et établir des inférences) ; s'endormir rapidement. (juste), éteindre les
 *   lumières., finir son jeu vidéo., retrouver son smartphone.
 * Texte : le dessin de la page 1. À table, devant une assiette pleine et sous le « Bon appétit ! » d'une personne
 *   hors du dessin, l'enfant se tient la joue enflée, les yeux plissés, entouré de traits de douleur ; autour de
 *   lui, les emballages vides de la journée (les canettes écrasées, le paquet de bonbons ouvert, le paquet de
 *   biscuits déchiré, les papiers des barres chocolatées) ; la fourchette est posée à côté de l'assiette. La
 *   réponse se déduit du signe (la main sur la joue) et du moment (le repas), comme les yeux ouverts sous le
 *   « Bonne nuit ! » de septembre ; la page 4 (l'abcès, la joue enflée) et la page 6 (« ni quand on mâche ») la
 *   confirment sans la donner.
 * Erreurs : un élément de la scène pris pour l'obstacle, la lumière de l'écran allumé (éteindre les lumières.),
 *   ici le paquet de bonbons, déjà ouvert et vide (ouvrir son paquet de bonbons.) ; une activité écrite sur une
 *   étiquette, « 1h15 de jeux vidéo » (finir son jeu vidéo.), ici « 3 canettes de soda », écrasées donc vides
 *   (finir sa canette de soda.) ; un objet à retrouver, le téléphone de « 1h de téléphone portable » (retrouver
 *   son smartphone.), ici la fourchette, bien visible à côté de l'assiette (retrouver sa fourchette.).
 */
const L01 = 'Ce que le dessin fait comprendre';
const genQ01 = () => {
    garde(ETIQUETTES.canettes.includes('canettes de soda') && ETIQUETTES.bonbons.includes('paquet de bonbons')
        && BULLE === 'Bon appétit !', 'Q01 : le dessin a changé');
    appuis('Q01', [[4, 'une enflure du visage'], [6, 'ni quand on mâche']]);
    return qcmSurLeDocument(
        ['mâcher sans avoir mal.', 'ouvrir son paquet de bonbons.', 'finir sa canette de soda.', 'retrouver sa fourchette.'],
        '<p>Sur le dessin de la page 1, l\'enfant se tient la joue car il n\'arrive pas à…</p>', L01);
};

/**
 * Q02 : Ce que l'auteur du dessin veut faire comprendre
 * Item : « L'auteur du dessin de la page 1 veut faire comprendre que les durées d'utilisation des écrans indiquées
 *   sont des durées… » (Rendre compte du sens global et identifier la visée) ; recommandées., trop longues.
 *   (juste), acceptables., très faibles.
 * Texte : les quatre étiquettes du dessin, « 3 canettes de soda », « 1 paquet de bonbons », « 6 biscuits »,
 *   « 2 barres chocolatées », en regard de l'enfant qui a mal aux dents : des quantités, comme les durées de
 *   septembre étaient des durées ; aucun mot du dessin ne dit ce qu'en pense l'auteur.
 * Erreurs : les chiffres lus comme un conseil (recommandées., gardé) ; une lecture neutre, la critique du dessin
 *   manquée (acceptables., gardé) ; le contresens complet (très faibles., gardé). La juste devient « trop
 *   grandes. », la forme qui convient à des quantités ; aucune page ne recommande de quantité, le piège reste
 *   entier.
 */
const L02 = 'Ce que l\'auteur du dessin veut faire comprendre';
const genQ02 = () => {
    garde(Object.values(ETIQUETTES).every((e) => /^\d+ /.test(e)), 'Q02 : une étiquette sans quantité');
    garde(!/recommand/i.test(texteDuDocument()), 'Q02 : le document ne doit recommander aucune quantité');
    return qcmSurLeDocument(['trop grandes.', 'recommandées.', 'acceptables.', 'très faibles.'],
        '<p>L\'auteur du dessin de la page 1 veut faire comprendre que les quantités de sucreries indiquées sont des'
        + ' quantités…</p>', L02);
};

/**
 * Q03 : Le sens d'un mot dans une citation
 * Item : « « La télévision, l'ordinateur, les jeux vidéo sur console ou sur ordinateur, l'utilisation d'Internet
 *   et du téléphone mobile sont associés à des éveils nocturnes [souligné] et à un sommeil de médiocre qualité. »
 *   (Page 2) Dans cette citation, « nocturnes » signifie… » (Mettre en relation des informations et établir des
 *   inférences) ; qui ont lieu la nuit. (juste), qui ont lieu la journée., volontaires., agréables.
 * Texte : « Les bonbons, les biscuits, les jus de fruits et les boissons gazeuses sucrées sont associés à des
 *   caries et à une usure de l'émail. » (page 2), « boissons gazeuses » souligné comme « éveils nocturnes ». Le
 *   mot se comprend par celui qu'on y entend (la nuit, le gaz) et par la phrase.
 * Erreurs : le sens contraire, la journée pour la nuit (qui ont lieu la journée.), ici sans bulles pour avec
 *   (qui ne contiennent pas de bulles.) ; deux adjectifs qui vont avec le nom sans avoir le sens du mot
 *   (volontaires., agréables.), ici glacées. et agréables. (gardé).
 */
const L03 = 'Le sens d\'un mot dans une citation';
const CITATION_Q03 = 'Les bonbons, les biscuits, les jus de fruits et les boissons gazeuses sucrées sont associés à'
    + ' des caries et à une usure de l\'émail.';
const genQ03 = () => {
    appuis('Q03', [[2, CITATION_Q03]]);
    const soulignee = CITATION_Q03.replace('boissons gazeuses', '<u>boissons gazeuses</u>');
    garde(soulignee !== CITATION_Q03, 'Q03 : expression à souligner introuvable');
    return qcmSurLeDocument(
        ['qui contiennent des bulles.', 'qui ne contiennent pas de bulles.', 'glacées.', 'agréables.'],
        `<p>« ${soulignee} » (Page 2)</p><p>Dans cette citation, « gazeuses » signifie…</p>`, L03);
};

/**
 * Q04 : Retrouver une cause dans le document
 * Item : « Le stress est provoqué par… » (Retrouver une information explicite plus ou moins aisément repérable) ;
 *   la violence des jeux vidéo. (juste), la lumière des écrans., l'excès de sédentarité., la sécrétion de
 *   mélatonine.
 * Texte : l'intertitre « Une érosion de l'émail » (page 3) : « les sodas, les jus de fruits et les boissons pour
 *   sportifs sont acides. Leur acidité ronge directement l'émail, sans l'aide des bactéries : c'est l'érosion. »
 *   La question nomme l'effet de l'intertitre, comme « le stress » ; la juste reformule la cause du paragraphe,
 *   comme « la violence des jeux vidéo » reformulait « certains jeux excessivement violents ».
 * Erreurs : la cause d'un autre paragraphe du passage, la lumière (« Un dérèglement hormonal »), ici les
 *   bactéries (« Des bactéries gourmandes ») que le paragraphe de l'érosion écarte en toutes lettres ; un autre
 *   paragraphe pris en entier, la sédentarité (l'excès de sédentarité.), ici le grignotage (« Des attaques à
 *   répétition », l'excès de grignotage.) ; un élément naturel du corps nommé dans un autre paragraphe, la
 *   mélatonine (la sécrétion de mélatonine.), ici la salive (la production de salive.).
 */
const L04 = 'Retrouver une cause dans le document';
const genQ04 = () => {
    appuis('Q04', [
        [3, 'Une érosion de l\'émail'], [3, 'Leur acidité ronge directement l\'émail, sans l\'aide des bactéries : c\'est l\'érosion.'],
        [2, 'Des bactéries gourmandes'], [3, 'Des attaques à répétition'], [3, 'Quand on grignote toute la journée'],
        [3, 'quand la salive est moins abondante'], [2, 'la bouche produit moins de salive'],
    ]);
    return qcmSurLeDocument(
        ['l\'acidité des boissons.', 'les bactéries de la plaque dentaire.', 'l\'excès de grignotage.', 'la production de salive.'],
        '<p>L\'érosion de l\'émail est provoquée par…</p>', L04);
};

/**
 * Q05 : Lire une durée sur le schéma de la page 5
 * Item : « Selon la page 5, au cours du cycle du sommeil, le sommeil paradoxal dure environ… » (Retrouver une
 *   information explicite plus ou moins aisément repérable) ; 5 minutes., 10 minutes. (juste), 1 heure 30.,
 *   2 heures.
 * Texte : le schéma de la page 5, la phase Déminéralisation (« L'émail perd des minéraux. On ne sent rien.
 *   environ 20 minutes ») et la phase Acidification (« environ 3 minutes ») ; la légende : « Après chaque repas,
 *   la bouche met 30 minutes à 1 heure à retrouver son état normal. »
 * Erreurs : la durée d'une autre phase du schéma, l'endormissement « 5 à 30 minutes » (5 minutes.), ici
 *   l'acidification (3 minutes.) ; les deux bornes de la durée d'ensemble, « Un cycle dure 1H30 à 2H00 »
 *   (1 heure 30., 2 heures.), ici celles du retour à l'état normal (30 minutes., 1 heure.).
 */
const L05 = 'Lire une durée sur le schéma de la page 5';
const genQ05 = () => {
    garde(phase('Déminéralisation').duree === 'environ 20 minutes' && phase('Acidification').duree === 'environ 3 minutes',
        'Q05 : les durées du schéma ont changé');
    garde(PHASES.filter((p) => p.duree).length === 2, 'Q05 : deux phases à durée, comme le schéma de septembre');
    garde(page(5).legende.includes('30 minutes à 1 heure'), 'Q05 : la légende ne donne plus le retour à l\'état normal');
    return qcmSurLeDocument(['20 minutes.', '3 minutes.', '30 minutes.', '1 heure.'],
        '<p>Selon la page 5, au cours du cycle de l\'attaque acide, la déminéralisation dure environ…</p>', L05);
};

/**
 * Q06 : Associer chaque description à sa phase
 * Item : « Grâce à la page 5, associer chaque description à la phase correspondante. » (Retrouver une information
 *   explicite plus ou moins aisément repérable) ; tableau, colonnes Sommeil lent profond, Latence, Sommeil lent
 *   léger ; lignes On est bien. (Sommeil lent léger), On se réveille. (Latence), On n'entend plus rien. (Sommeil
 *   lent profond).
 * Texte : les phases du schéma de la page 5 : Déminéralisation (« L'émail perd des minéraux. »), Neutralisation
 *   (« La salive chasse l'acide. »), Reminéralisation (« L'émail récupère des minéraux, jusqu'au repas
 *   suivant. ») ; la ligne coupe la description, comme « On se réveille. » coupait « On se réveille ou on
 *   commence un nouveau cycle. ».
 * Erreurs : deux phases aux noms presque pareils, séparées par un mot (Sommeil lent léger, profond ; très léger
 *   et très profond sur le schéma), ici Déminéralisation et Reminéralisation, que seuls « perd » et « récupère »
 *   séparent dans les descriptions ; une phase au nom savant que la description ne fait pas deviner (Latence :
 *   On se réveille.), ici Neutralisation (La salive chasse l'acide.) ; une phase voisine reste sur le schéma
 *   sans être dans le tableau, comme le sommeil très léger, ici Acidification (« Les bactéries changent le sucre
 *   en acide. »). Mêmes colonnes au même endroit, trois lignes, mêmes cases justes (troisième, deuxième,
 *   première colonne).
 */
const L06 = 'Associer chaque description à sa phase';
const genQ06 = () => {
    const lignes = [
        ['L\'émail récupère des minéraux.', 'Reminéralisation'],
        ['La salive chasse l\'acide.', 'Neutralisation'],
        ['L\'émail perd des minéraux.', 'Déminéralisation'],
    ];
    lignes.forEach(([ligne, nom]) => garde(descriptionDe(nom).startsWith(ligne.replace(/\.$/, '')),
        `Q06 : « ${ligne} » n'ouvre pas la description de ${nom}`));
    garde(PHASES.every((p) => !p.lignes.join(' ').toLowerCase().includes(p.nom.toLowerCase())), 'Q06 : un nom de phase répété dans sa description');
    return tableauSurLeDocument(lignes, ['Déminéralisation', 'Neutralisation', 'Reminéralisation'],
        '<p>Grâce à la page 5, associer chaque description à la phase correspondante.</p>', L06);
};

/**
 * Q07 : Le sujet que le document ne traite pas
 * Item : « Ce document donne des informations sur tous ces sujets sauf 1. Lequel ? » (Rendre compte du sens global
 *   et identifier la visée) ; L'importance d'un bon sommeil, L'effet des écrans sur le sommeil, Le fonctionnement
 *   du sommeil, Les astuces pour un bon sommeil (juste).
 * Texte : tout le document : l'effet du sucre sur les dents (pages 2 et 3), les conséquences des caries (page 4),
 *   le cycle de l'attaque acide (page 5), la définition d'une bouche en bonne santé (page 6) ; aucune astuce ni
 *   aucun conseil, ce que le générateur vérifie sur tout le texte affiché.
 * Erreurs : les trois sujets traités, chacun par une partie du document, gardés dans le même ordre :
 *   L'importance d'avoir des dents en bonne santé (page 4, comme les conséquences du manque de sommeil),
 *   L'effet du sucre sur les dents (pages 2 et 3), Le déroulement d'une attaque acide (page 5, comme le
 *   fonctionnement du sommeil) ; le piège : la page 6, une définition par critères, prise pour des astuces.
 */
const L07 = 'Le sujet que le document ne traite pas';
const genQ07 = () => {
    garde(!/astuce|conseil|il faut|évite|pensez|n'oubliez|brossez|buvez|mangez|limitez/i.test(texteDuDocument()),
        'Q07 : le document donne un conseil, le sujet « astuces » ne serait plus absent');
    appuis('Q07', [[2, 'Comment le sucre abîme-t-il les dents ?'], [4, 'des difficultés pour manger']]);
    garde(page(5).title === 'Le cycle de l\'attaque acide' && page(6).title.startsWith('Qu\'est-ce qu\'une bouche'),
        'Q07 : les titres des pages 5 et 6 ont changé');
    return qcmSurLeDocument(
        ['Les astuces pour garder des dents en bonne santé', 'L\'importance d\'avoir des dents en bonne santé',
            'L\'effet du sucre sur les dents', 'Le déroulement d\'une attaque acide'],
        '<p>Ce document donne des informations sur tous ces sujets sauf 1. Lequel ?</p>', L07);
};

/**
 * Q08 : Où placer une information nouvelle
 * Item : « Jouer à des jeux vidéo non adaptés à son âge peut provoquer des cauchemars. Cette information n'est pas
 *   dans le document. Elle pourrait se trouver dans le paragraphe… » (Rendre compte du sens global et identifier
 *   la visée) ; « Comment ces médias influencent-ils le sommeil ? » (juste), « Le manque de sommeil altère le
 *   cerveau des ados », « Le cycle du sommeil », « Qu'est-ce qu'un sommeil de qualité ? » (choix lus sur la
 *   capture : la base coupe les deux premiers).
 * Texte : l'information nouvelle, vraie et absente du document : « Les bonbons acidulés contiennent à la fois du
 *   sucre et de l'acide : ils abîment donc les dents de deux façons. » (Minnesota Dental Association, « Pucker
 *   Up! » : les bonbons acidulés sont très acides et l'acide use l'émail ; leur sucre nourrit les bactéries des
 *   caries, OMS). Elle dit comment un produit sucré abîme les dents : la question de « Comment le sucre abîme-t-il
 *   les dents ? » (page 2), dont les paragraphes traitent du sucre puis de l'acidité, comme l'information des
 *   cauchemars allait avec les jeux violents du paragraphe sur le stress.
 * Erreurs : le titre des conséquences (« Le manque de sommeil altère le cerveau des ados »), ici « La carie fait
 *   aussi manquer l'école » (page 4) ; le titre du schéma, rapproché par un mot (cauchemars, rêves, sommeil
 *   paradoxal), ici « Le cycle de l'attaque acide » (acide, acidulés) ; le titre de la définition, rapproché par
 *   l'idée (un sommeil gâché), ici « Qu'est-ce qu'une bouche en bonne santé ? » (des dents abîmées).
 */
const L08 = 'Où placer une information nouvelle';
const genQ08 = () => {
    appuis('Q08', [[2, 'Comment le sucre abîme-t-il les dents ?'], [4, 'La carie fait aussi manquer l\'école'],
        [3, 'Leur acidité ronge directement l\'émail']]);
    garde(page(5).title === 'Le cycle de l\'attaque acide' && page(6).title === 'Qu\'est-ce qu\'une bouche en bonne santé ?',
        'Q08 : les titres des pages 5 et 6 ont changé');
    garde(!/acidulé/i.test(texteDuDocument()), 'Q08 : l\'information nouvelle est déjà dans le document');
    return qcmSurLeDocument(
        ['« Comment le sucre abîme-t-il les dents ? »', '« La carie fait aussi manquer l\'école »',
            '« Le cycle de l\'attaque acide »', '« Qu\'est-ce qu\'une bouche en bonne santé ? »'],
        '<p>Les bonbons acidulés contiennent à la fois du sucre et de l\'acide : ils abîment donc les dents de deux'
        + ' façons.</p><p>Cette information n\'est pas dans le document. Elle pourrait se trouver dans le'
        + ' paragraphe…</p>', L08);
};

/**
 * Q09 : Associer chaque information à sa page
 * Item : « Associer chaque information à la page à laquelle elle se trouve. » (Rendre compte du sens global et
 *   identifier la visée) ; tableau, colonnes Page 3, Page 5, Page 6 ; lignes Les conséquences de l'exposition à
 *   la lumière d'écran (Page 3), La définition d'un sommeil de qualité (Page 6), La description des différentes
 *   phases du sommeil (Page 5).
 * Texte : page 3, « Une érosion de l'émail » (l'acidité des boissons ronge l'émail, qui ne repousse jamais) ;
 *   page 5, le schéma des phases de l'attaque acide ; page 6, « Qu'est-ce qu'une bouche en bonne santé ? ».
 * Erreurs : « Les conséquences de… » attire vers la page 4 des conséquences, absente des colonnes : il faut
 *   retrouver le paragraphe de la page 3 (gardé : Les conséquences de l'acidité des boissons sur l'émail ; le
 *   mot « acide » attire aussi vers la page 5) ; la définition (page 6) et la description des phases (page 5)
 *   confondues. Mêmes colonnes, trois lignes dans l'ordre de l'item, mêmes cases justes (première, troisième,
 *   deuxième colonne).
 */
const L09 = 'Associer chaque information à sa page';
const genQ09 = () => {
    appuis('Q09', [[3, 'Leur acidité ronge directement l\'émail'], [3, 'l\'émail rongé ne repousse jamais'],
        [4, 'Les caries ont donc des répercussions']]);
    garde(page(5).images?.length === 1 && PHASES.length >= 3 && page(6).title === 'Qu\'est-ce qu\'une bouche en bonne santé ?',
        'Q09 : les pages 5 et 6 ont changé');
    return tableauSurLeDocument(
        [
            ['Les conséquences de l\'acidité des boissons sur l\'émail', 'Page 3'],
            ['La définition d\'une bouche en bonne santé', 'Page 6'],
            ['La description des différentes phases de l\'attaque acide', 'Page 5'],
        ],
        ['Page 3', 'Page 5', 'Page 6'],
        '<p>Associer chaque information à la page à laquelle elle se trouve.</p>', L09);
};

const GENERATORS = {
    q01_qcm_unique: genQ01,
    q02_qcm_unique: genQ02,
    q03_qcm_unique: genQ03,
    q04_qcm_unique: genQ04,
    q05_qcm_unique: genQ05,
    q06_tableau: genQ06,
    q07_qcm_unique: genQ07,
    q08_qcm_unique: genQ08,
    q09_tableau: genQ09,
};

export const ITEMS = [
    { questionNum: 'Q01', formatKey: 'q01_qcm_unique', libelle: L01, bonneReponseOfficielle: 's’endormir rapidement.' },
    { questionNum: 'Q02', formatKey: 'q02_qcm_unique', libelle: L02, bonneReponseOfficielle: 'trop longues.' },
    { questionNum: 'Q03', formatKey: 'q03_qcm_unique', libelle: L03, bonneReponseOfficielle: 'qui ont lieu la nuit.' },
    { questionNum: 'Q04', formatKey: 'q04_qcm_unique', libelle: L04, bonneReponseOfficielle: 'la violence des jeux vidéo.' },
    { questionNum: 'Q05', formatKey: 'q05_qcm_unique', libelle: L05, bonneReponseOfficielle: '10 minutes.' },
    {
        questionNum: 'Q06',
        formatKey: 'q06_tableau',
        libelle: L06,
        bonneReponseOfficielle: '[On se réveille.|Latence][On est bien.|Sommeil lent léger]'
            + '[On n’entend plus rien.|Sommeil lent profond]',
    },
    { questionNum: 'Q07', formatKey: 'q07_qcm_unique', libelle: L07, bonneReponseOfficielle: 'Les astuces pour un bon sommeil' },
    { questionNum: 'Q08', formatKey: 'q08_qcm_unique', libelle: L08, bonneReponseOfficielle: '« Comment ces médias influencent-ils... ? »' },
    {
        questionNum: 'Q09',
        formatKey: 'q09_tableau',
        libelle: L09,
        bonneReponseOfficielle: '[Les conséquences de l’exposition à la lumière d’écran|Page 3]'
            + '[La définition d’un sommeil de qualité|Page 6][La description des différentes phases du sommeil|Page 5]',
    },
];

export const CATEGORIES = ITEMS.map(({ questionNum, formatKey, libelle }) => ({
    id: questionNum.toLowerCase(),
    label: `${questionNum} · ${libelle}`,
    formatsList: [{ key: formatKey, label: formatKey.endsWith('_tableau') ? 'Tableau' : 'QCM' }],
}));

export const generate = (typeExercice) => {
    const key = GENERATORS[typeExercice] ? typeExercice : randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
